import { TFunction } from 'i18next';

type DurationLabelSet = 'timers.times' | 'timers.timesShort';

const formatMinutesAsDuration = (
  mins: number,
  translate: TFunction,
  labelSet: DurationLabelSet,
) => {
  const days = (mins / (60 * 24)) | 0;
  const hours = (mins / 60) | 0;
  const minutes = mins % 60 | 0;

  return `${days ? `${translate(`${labelSet}.day`, { count: days })} ` : ''}${
    hours ? `${translate(`${labelSet}.hour`, { count: hours })} ` : ''
  }${minutes ? translate(`${labelSet}.minute`, { count: minutes }) : ''}`.trim();
};

export const minutesToHours = (mins: number = 0, translate: TFunction) =>
  formatMinutesAsDuration(mins, translate, 'timers.times');

export const minutesToHoursShort = (mins: number = 0, translate: TFunction) =>
  formatMinutesAsDuration(mins, translate, 'timers.timesShort');
